<script setup lang="ts">
import type {FusionSharedDtosGalleryBannerOutputDto} from "~/types/api/api";

const {$api} = useNuxtApp()

const isLoading = ref<boolean>(false);
const slides = ref<FusionSharedDtosGalleryBannerOutputDto[]>([]);

useHead({
  titleTemplate: (title) =>
      title ? `${title} - یاسان` : 'یاسان'
})

onMounted(async () => {
  try {
    isLoading.value = true;
    const response = await $api.api.galleryGetLoginBannersList()
    if (response.data.length === 0) {
      slides.value = [{
        id: "bd165306-3b5d-4a31-b97c-f9f3426ccec7",
        url: "/new/images/auth-slider/slider-1.webp",
        href: "#",
        title: "default"
      }]
    } else {
      slides.value = response.data;
    }
  } finally {
    isLoading.value = false;
  }
})
</script>

<template>
  <VApp>
    <VLocaleProvider :rtl="true">
      <VMain>
        <VRow class="auth-layout" no-gutters>
          <VCol cols="18">
            <div class="auth-container">
              <div>
<!--                content-class="align-self: center;width: 100%;text-align: center;flex: 1;display: flex;"-->
                <VImg src="/new/logo-with-text.png" :height="80"/>
                <VCard class="auth-card">
                  <VCardText>
                    <NuxtPage/>
                  </VCardText>
                </VCard>
              </div>
            </div>
          </VCol>
        </VRow>
      </VMain>
    </VLocaleProvider>
  </VApp>
</template>
